export default {
    name: 'q-file-upload',
    props: {
        name: {
            type: String,
            default: 'file_upload[]'
        },
        multiple: {
            type: Boolean,
            default: true
        },
        gallery: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'file-upload-outline'
        },
        accept: {
            type: String,
            default: ''
        }
    },
    methods: {
        onFileUpload() {
            this.$emit('input', this.$refs.files.files);
        }
    }
};
